import classNames from 'classnames';
import {isEmpty, keyBy} from 'lodash';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchMatchDays} from '../../../../../../actions/entities/match';
import {fetchFullPlayers} from '../../../../../../actions/entities/player';
import {fetchStatsPlayersGoals} from '../../../../../../actions/entities/statistics/players';
import Filters from '../../../../../../components/Filters';
import FilterGamesWeek from '../../../../../../components/Filters/GamesWeek';
import FilterLocation from '../../../../../../components/Filters/Location';
import FilterSeason from '../../../../../../components/Filters/Season';
import Loader from '../../../../../../components/Loader';
import {getChampionshipClubs} from '../../../../../Tools/Tds/Widgets/TdsList';
import {getChampionships} from '../../../../../../actions/entities/championships';
import {getChampionshipId} from '../../../../../../helpers/championship';
import getAvailableFlagsButtons from '../../../../../../helpers/getAvailableFlagsButtons';

import './index.css';

class StatsPlayersGoalsWidget extends React.Component {
  constructor(props) {
    super(props);

    const month = moment().month();
    const year = moment().year();
    // Si on est en août ou plus la saison est l'année en cours.
    // Année en cours = 2018
    // Si mois < août Alors saison = 2017 Sinon saison = 2018
    const season = month >= 6 ? year : year - 1;

    this.state = {
      filters: {championship: 'FR', season, gamesWeeks: []},
      order: {key: 'totalMatches', value: 'desc'},
      isFetching: false,
      matchDays: {},
      highlightRefreshBtn: false,
      clubs: undefined,
    };
  }

  componentDidMount() {
    this.props.dispatch(getChampionships()).then(() => this.fetchMatchDays());
    this.props.dispatch(
      getChampionshipClubs({
        onSuccess: response => this.setState({clubs: response}),
      }),
    );
  }

  updateFilters(filter) {
    this.setState({filters: {...this.state.filters, ...filter}});
  }

  selectOrChangeOrder(key) {
    if (key === this.state.order.key)
      this.setState({
        order: {key, value: this.state.order.value === 'asc' ? 'desc' : 'asc'},
      });
    else {
      const newOrder = {key};
      // The switch is necessary for the default sortOrder each orderType
      switch (key) {
        case 'lastName':
          newOrder.value = 'asc';
          break;
        case 'club':
          newOrder.value = 'asc';
          break;
        case 'goals':
          newOrder.value = 'desc';
          break;
        case 'mpgGoals':
          newOrder.value = 'desc';
          break;
        case 'mpgStops':
          newOrder.value = 'desc';
          break;
        case 'totalMatches':
          newOrder.value = 'desc';
          break;
        case 'avgGoals':
          newOrder.value = 'desc';
          break;
        case 'avgMpgGoals':
          newOrder.value = 'desc';
          break;
        case 'avgMpgStops':
          newOrder.value = 'desc';
          break;
        case 'avgAllGoals':
          newOrder.value = 'desc';
          break;
        default:
          newOrder.value = 'desc';
      }
      this.setState({order: newOrder});
    }
  }

  onError = error => {
    this.setState({isFetching: false});
    swal({
      title: `Oops...`,
      type: 'error',
      html:
        `Something went wrong !<br/>${error}<br/>` +
        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
    });
  };

  fetchMatchDays() {
    const callBacks = {
      onError: this.onError,
      onRequest: () => this.setState({isFetching: true}),
      onSuccess: response => {
        this.setState({isFetching: false, matchDays: response});
        this.fetchPlayers();
      },
    };

    if (!this.state.isFetching) {
      const {season} = this.state.filters;
      const payload = {season};
      this.props.dispatch(fetchMatchDays(payload, callBacks));
    }
  }

  fetchPlayers() {
    const callBacks = {
      onError: this.onError,
      onRequest: () => this.setState({isFetching: true}),
      onSuccess: () => {
        this.setState({isFetching: false});
        this.fetchStats();
      },
    };

    if (!this.state.isFetching) {
      const {championship} = this.state.filters;
      const payload = {
        championship: getChampionshipId(championship),
      };

      this.props.dispatch(fetchFullPlayers(payload, undefined, callBacks));
    }
  }

  fetchStats() {
    const callBacks = {
      onError: this.onError,
      onRequest: () => this.setState({isFetching: true}),
      onSuccess: () => {
        this.setState({isFetching: false});
        this.notifyRefresh(false);
      },
    };

    if (!this.state.isFetching) {
      const {season, championship} = this.state.filters;
      const payload = {
        season,
        championship: getChampionshipId(championship),
      };
      this.props.dispatch(fetchStatsPlayersGoals(payload, callBacks));
    }
  }

  static getSeasonOptions() {
    const year = moment().year();
    const season = moment().month() >= 7 ? year : year - 1;

    const seasonOptions = [];
    for (let i = parseInt(season, 10); i >= 2017; i--) {
      seasonOptions.push({value: i.toString(), text: `${i} - ${i + 1}`});
    }

    return seasonOptions;
  }

  getGamesWeekOptions() {
    const {matchDays, filters} = this.state;

    const matchDaysByChamp =
      matchDays?.championships?.[getChampionshipId(filters.championship)]
        ?.gameWeekNumbers;

    return (
      matchDaysByChamp &&
      matchDaysByChamp.map(day => ({value: day, text: `Day ${day}`}))
    );
  }

  static getPercent(nb, total) {
    const percent = (parseInt(nb, 10) / total) * 100;
    return parseInt(numeral(percent > 100 ? 100 : percent).format('0,0'), 10);
  }

  notifyRefresh(value) {
    const {highlightRefreshBtn} = this.state;
    this.setState({
      highlightRefreshBtn: value !== undefined ? value : !highlightRefreshBtn,
    });
  }

  getSumsByFilters() {
    const {filters, clubs} = this.state;
    const {data} = this.props;
    if (Object.keys(data).length === 0) return null;

    const championship = getChampionshipId(filters.championship);

    return (
      clubs &&
      this.props.players &&
      Object.values(data).map(player => {
        const id = player.playerId;
        const playerInfo = this.props.players[id] || {};

        if (
          !clubs?.[playerInfo.clubId]?.championships?.[championship]?.active
        ) {
          return null;
        }

        const p = {
          id,
          club: playerInfo.clubId,
          firstName: playerInfo.firstName,
          lastName: playerInfo.lastName,
          goals: 0,
          mpgGoals: 0,
          mpgStops: 0,
          totalMatches: 0,
          avgGoals: 0,
          avgMpgGoals: 0,
          avgMpgStops: 0,
          avgAllGoals: 0,
        };
        const date = parseInt(filters.gamesWeeks, 10) || undefined;

        if (date) {
          const stat = player.gameWeeks[date];
          p.goals += stat?.goals ? parseInt(stat?.goals, 10) : 0;
          p.mpgGoals += stat?.mpgGoals ? parseInt(stat?.mpgGoals, 10) : 0;
          p.mpgStops += stat?.mpgStops ? parseInt(stat?.mpgStops, 10) : 0;
          p.totalMatches += stat?.totalMatches
            ? parseInt(stat?.totalMatches, 10)
            : 0;
        } else {
          map(player.gameWeeks, stat => {
            p.goals += stat.goals ? parseInt(stat.goals, 10) : 0;
            p.mpgGoals += stat.mpgGoals ? parseInt(stat.mpgGoals, 10) : 0;
            p.mpgStops += stat.mpgStops ? parseInt(stat.mpgStops, 10) : 0;
            p.totalMatches += stat.totalMatches
              ? parseInt(stat.totalMatches, 10)
              : 0;
          });
        }

        if (p.totalMatches) {
          p.avgGoals = p.goals / p.totalMatches;
          p.avgMpgGoals = p.mpgGoals / p.totalMatches;
          p.avgMpgStops = p.mpgStops / p.totalMatches;
          p.avgAllGoals = (p.goals + p.mpgGoals) / p.totalMatches;
        }

        return p;
      })
    );
  }

  renderTable() {
    const {order} = this.state;
    const cols = {
      lastName: 'Name',
      club: 'Club',
      goals: 'Real goals',
      mpgGoals: 'MPG goals',
      mpgStops: 'MPG stops',
      avgGoals: 'AVG Real goals',
      avgMpgGoals: 'AVG MPG goals',
      avgMpgStops: 'AVG MPG stops',
      avgAllGoals: 'AVG All goals',
      totalMatches: 'Games played',
    };

    const players = this.getSumsByFilters();
    return !players ? (
      <p className="text-center px-3 pb-3">No data to show</p>
    ) : (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>{this.renderThs(cols)}</tr>
          </thead>
          <tbody>
            {orderBy(players, [order.key], [order.value]).map(
              player =>
                player && (
                  <tr key={player.id}>
                    <td>
                      <strong>{player.lastName}</strong>
                      {player.firstName && ` ${player.firstName}`}
                    </td>
                    <td>{player.club}</td>
                    <td className="text-center">
                      {numeral(player.goals).format('0,0')}
                    </td>
                    <td className="text-center">
                      {numeral(player.mpgGoals).format('0,0')}
                    </td>
                    <td className="text-center">
                      {numeral(player.mpgStops).format('0,0')}
                    </td>
                    <td className="text-center">
                      {numeral(player.avgGoals).format('0,0.00')}
                    </td>
                    <td className="text-center">
                      {numeral(player.avgMpgGoals).format('0,0.00')}
                    </td>
                    <td className="text-center">
                      {numeral(player.avgMpgStops).format('0,0.00')}
                    </td>
                    <td className="text-center">
                      {numeral(player.avgAllGoals).format('0,0.00')}
                    </td>
                    <td className="text-center">
                      {numeral(player.totalMatches).format('0,0')}
                    </td>
                  </tr>
                ),
            )}
          </tbody>
        </table>
      </div>
    );
  }

  renderThs(cols, hideSort = false) {
    const {order} = this.state;
    return map(cols, (value, key) => (
      <th key={key}>
        <span
          onClick={() => this.selectOrChangeOrder(key)}
          className={classNames('orderBtn', {
            'text-primary': order.key === key && !hideSort,
          })}>
          {value}
          <span className={classNames('ml-1', {hidden: hideSort})}>
            <i
              className={classNames('fa', {
                'fa-sort': order.key !== key,
                [`fa-sort-${order.value}`]: order.key === key,
              })}
            />
          </span>
        </span>
      </th>
    ));
  }

  render() {
    const {isFetching, highlightRefreshBtn} = this.state;
    const {championships} = this.props;
    if (isEmpty(championships)) {
      return <></>;
    }
    return (
      <div id="stats-players-goals-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-futbol-o" />
              {` Players goals per MPG match`}
            </h3>
          </div>
          <div className="box-body">
            <Filters>
              <FilterLocation
                label="Championship:"
                availableButtons={getAvailableFlagsButtons(
                  this.props.championships,
                )}
                onChange={championship => {
                  this.updateFilters({championship});
                  this.notifyRefresh(true);
                }}
                initialValue={this.state.filters.championship}
              />
              <FilterSeason
                label="Season:"
                onChange={season => {
                  this.updateFilters({season});
                  this.notifyRefresh(true);
                }}
                options={StatsPlayersGoalsWidget.getSeasonOptions()}
                initialValue={this.state.filters.season.toString()}
              />
              <FilterGamesWeek
                label="Match days:"
                onChange={gamesWeeks => this.updateFilters({gamesWeeks})}
                options={this.getGamesWeekOptions()}
                selectProps={{multiple: true}}
              />
              <button
                onClick={this.fetchMatchDays.bind(this)}
                className={classNames('btn btn-submit', {
                  'btn-default': !highlightRefreshBtn,
                  'btn-success': highlightRefreshBtn,
                })}>
                <i
                  className={classNames('fa fa-refresh', {
                    'fa-spin': isFetching,
                  })}
                />
              </button>
            </Filters>
          </div>
          {isFetching && <Loader />}
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const {statistics, players, championships} = state.app;
    return {
      data: statistics.players.goals,
      players: keyBy(players?.response?.players, 'id'),
      championships: championships.list.data,
    };
  },
  dispatch => ({dispatch}),
)(StatsPlayersGoalsWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Players/Goals/index.js